import styled from "styled-components";

const StyledDiv = styled.div`
  text-align: left;
`;

export default StyledDiv;
